import styled from 'styled-components';

export const Button = styled.button`
  background: none;
  display: flex;
  border: none;
`;
